export enum UserActionTypes {
  TOP_PAGE_AS_CONTROL = "Set Top Page as New Control",
  SET_SHIP_DATE = "Set Ship Date",
  RESET_CONTROL_DATA = "Reset Cumulative Control Data",
  CHANGE_CONTROL_ASSET = "Control Asset Change",
}
